import { Messages } from '../../codegen/Localize';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IContentInfo } from '../models/IContentInfo';
import { Module } from '../Module';
import { Databases } from '../resources/Databases';
import { Tables } from '../resources/Tables';
import { IResult } from '../ServerApi/types/IResponse';
import { IUserName } from '../ServerApi/types/IUser';
import { ToasterService, ToastType } from '../services/ToasterService';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { IConfirmChangeOwnerScope } from './ContentActions';
import { SearchSuggestionsService } from './SearchSuggestionsService';


export class ChangeExternalContentContactAction {

  public static $inject = [
    'Databases',
    'Tables',
    'ConfirmActionDialog',
    'SearchSuggestionsService',
    'ToasterService'
  ];

  constructor(
    private Databases: Databases,
    private Tables: Tables,
    private ConfirmActionDialog: ConfirmActionDialog,
    private suggestions: SearchSuggestionsService,
    private toaster: ToasterService,
  ) { }

  public confirmChangeContact(externalContentType: string, externalContentItem: IContentInfo, context: IActionContext): ng.IPromise<IResult> {

    const contactPicker = {
      prompt: Messages.changeContactPrompt({ CONTENT_NAME: L10n.elideIfLong(externalContentItem.name) }),
      ownerQuery: (matchText: string) => this.suggestions.usersWithoutGuest(matchText),
      targetOwner: <IUserName>null
    };

    const newDialogScope = <IConfirmChangeOwnerScope>context.scope.$new();
    newDialogScope.ownerPicker = contactPicker;
    let currentContactId: string = null;
    if (!!externalContentItem.contact) {
      currentContactId = externalContentItem.contact.id;
    }

    let externalContentService: Databases | Tables;
    if (externalContentType === 'database') {
      externalContentService = this.Databases;
    } else {
      externalContentService = this.Tables;
    }

    return this.ConfirmActionDialog.open({
      scope: newDialogScope,
      title: Messages.changeContact(),
      bodyTemplateUrl: 'changeOwnerDialog.html',
      actionName: Messages.changeContactConfirm(),
      action: (dialogInstance: IConfirmActionDialogInstance) => {

        // Todo: Improve this
        return externalContentService.setContact(({
          contactId: contactPicker.targetOwner.id,
          contactType: 'User',
          ids: [externalContentItem.vizportalId],
        })).then((result: IResult) => {
          this.toast(result, Messages.changeContactError({ CONTENT_NAME: externalContentItem.name }),
          Messages.changeContactSuccess({ CONTACT_NAME: contactPicker.targetOwner.displayName }));
        });
      },
      confirmDisabled: () => !contactPicker.targetOwner || contactPicker.targetOwner.id === currentContactId
    }).result.finally(() => newDialogScope.$destroy());
  }

  private toast(result: IResult, errorMessage: string, successMessage: string): any {
    if (result.errors && result.errors.length > 0) {
      this.toaster.pop({
        type: ToastType.Error,
        text: errorMessage
      });
    } else {
      this.toaster.pop({
        type: ToastType.Info,
        text: successMessage
      });
    }
  }
}

Module.instance().service('ChangeExternalContentContactAction', ChangeExternalContentContactAction);
